//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import pdf from 'vue-pdf';
import { downFile } from '@/api/manage';
import IframePageContent from "../layouts/IframeFReportView";
export default {
  name: 'PDFModal',
  components: {
    IframePageContent: IframePageContent,
    pdf: pdf
  },
  props: {
    showModal: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  data: function data() {
    return {
      title: '',
      visible: false,
      loading: false,
      url: '',
      pageNum: 1,
      pageTotalNum: 1,
      pageRotate: 0,
      // 加载进度
      loadedRatio: 0,
      curPageNum: 0,
      screenWidth: document.body.clientWidth
    };
  },
  mounted: function mounted() {
    var that = this;

    window.onresize = function () {
      return function () {
        window.screenWidth = document.body.clientWidth;
        that.screenWidth = window.screenWidth;
      }();
    };
  },
  methods: {
    showPDF: function showPDF(name, url, model) {
      this.title = name;
      this.loading = true;
      console.log(model);

      if (model == 'url') {
        this.visible = true;
        this.url = url;
        this.loading = false;
      } else {
        if (!/\.(image|webp|png|svg|gif|jpg|jpeg|bmp|ico|pdf)$/i.test(name)) {
          // 浏览器无法直接预览文件
          window.open(url);
        } else {
          //浏览器可以预览的文件
          this.visible = true;
          this.url = url;
          this.loading = false;
          /*this.visible = true;
            //读取文件流转换后打开
            downFile(url, "").then((res) => {
              if(res&&res.size>0){
                this.url = res
                var binaryData = [];
                binaryData.push(res);
                var file =window.URL.createObjectURL(new Blob(binaryData, {type:"application/pdf"}));
                // this.url = pdf.createLoadingTask(file)
                this.url = file
              }else {
                this.$message.warning('加载失败,未找到相关文件!')
                this.hideModal()
              }
            }).finally(() => {
              this.loading = false;
            })*/
        }
      }
    },
    showImg: function showImg(url) {
      this.showPDF('', url, 'url');
    },
    hideModal: function hideModal() {
      this.visible = false;
      this.pageNum = 1;
      this.pageTotalNum = 1;
      this.pageRotate = 0;
      this.loadedRatio = 0;
      this.curPageNum = 0;
      this.title = '';
      this.url = '';
    }
  }
};